const id_master_attribute = {
    "": "atribut",
    name: "nama atribut",
    add: "tambah atribut",
    edit: "ubah atribut",

    error: {
        name: "Nama atribut tidak boleh kosong.",
        create: "Gagal membuat atribut.",
        delete: "Gagal menghapus atribut.",
        edit: "Gagal mengubah atribut.",
    },

    success: {
        create: "Berhasil membuat atribut.",
        delete: "Berhasil menghapus atribut.",
        edit: "Berhasil mengubah atribut.",
    }
}

export default id_master_attribute;